"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _CountryFlag = _interopRequireDefault(require("@kiwicom/orbit-components/lib/CountryFlag"));
var _Theme = require("../../../records/Theme");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const Container = /*#__PURE__*/_styledComponents.default.button.withConfig({
  displayName: "AirportResult__Container",
  componentId: "sc-1pft6nj-0"
})(["margin:0;border:none;display:flex;cursor:pointer;height:48px;width:100%;padding:12px;background:", ";text-align:start;box-shadow:0 1px 0 ", ";transition:background ", ";&:hover{background:", ";}&:focus{outline:none;}"], ({
  theme,
  selected
}) => theme.orbit[selected ? "paletteCloudNormal" : "paletteWhite"], ({
  theme
}) => theme.orbit.paletteCloudNormal, ({
  theme
}) => theme.orbit.durationNormal, ({
  theme
}) => theme.orbit.paletteCloudNormal);
Container.defaultProps = {
  theme: _Theme.themeDefault
};
const Name = /*#__PURE__*/_styledComponents.default.span.withConfig({
  displayName: "AirportResult__Name",
  componentId: "sc-1pft6nj-1"
})(["direction:ltr;margin:0 6px;"]);
const AirportResult = ({
  item,
  selected,
  onClick
}) => {
  var _item$country, _item$city;
  const handleClick = () => {
    if (typeof item.locationId === "string") {
      onClick(item.locationId);
    }
  };
  // TODO: this is bad, figure out what to show instead
  const country = ((_item$country = item.country) === null || _item$country === void 0 ? void 0 : _item$country.locationId) || "anywhere";
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(Container, {
    onClick: handleClick,
    selected: selected,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_CountryFlag.default, {
      code: country.toLowerCase()
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(Name, {
      children: `${String((_item$city = item.city) === null || _item$city === void 0 ? void 0 : _item$city.name)} (${String(item.locationId)})`
    })]
  });
};
var _default = AirportResult;
exports.default = _default;